import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const PageTour = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.63 5.49L19.54 3.43C19.42 3.31 19.27 3.25 19.1 3.25H12V2.62C12 2.28 11.72 2 11.37 2C11.02 2 10.74 2.28 10.74 2.62V3.24H5.12C4.77 3.24 4.49 3.52 4.49 3.86V8.88C4.49 9.22 4.77 9.5 5.12 9.5H10.75V11.38H4.9C4.74 11.38 4.58 11.44 4.46 11.56L2.37 13.61C2.13 13.85 2 14.16 2 14.5C2 14.84 2.13 15.15 2.37 15.39L4.46 17.45C4.58 17.57 4.73 17.63 4.9 17.63H10.75V21.38C10.75 21.72 11.03 22 11.38 22C11.73 22 12.01 21.72 12.01 21.38V17.63H18.89C19.23 17.63 19.52 17.35 19.52 17.01V12.01C19.52 11.67 19.24 11.39 18.89 11.39H12.01V9.51H19.11C19.27 9.51 19.43 9.45 19.55 9.33L21.64 7.27C21.88 7.03 22.01 6.72 22.01 6.38C22.01 6.04 21.88 5.73 21.64 5.49H21.63ZM18.26 12.63V16.38H5.16L3.25 14.51L5.16 12.63H18.25H18.26ZM18.85 8.25H5.75V4.5H18.84L20.75 6.37L18.84 8.25H18.85Z" />
  </svg>
)

export default withDefaultStyles(PageTour)
